import { CategoryType } from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/ContentServerProxy/types';
import { TimeSeriesPoint } from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/hooks/classes/TimeSeriesData';
import { METRICTYPE } from 'src/utils/entityDefinitions';

export type Category = { id: number; name: string };
export type CategoryValue = [string, number];
export type ContentScoreByCategoryData = {
  categories: Category[];
  data: CategoryValue[];
  metricType: METRICTYPE;
  type: 'column' | string;
};

export enum KeywordFilter {
  Usage = 'Usage',
  Productivity = 'Productivity',
  Popularity = 'Popularity'
}

export interface GaugeData {
  title: string;
  percentage: number;
  change: number;
  value: number;
  filterKey: KeywordFilter;
}

export type KeywordPerformanceGaugeData = GaugeData[];

export type BarChartData = {
  chartData: ContentScoreByCategoryData[];
  categoryType?: CategoryType;
};

export interface ContentSplineChartData {
  chartData: {
    primaryMetrics: TimeSeriesPoint[];
    secondaryMetrics: TimeSeriesPoint[];
  };
  legendData: {
    primaryLegendMetric: number;
    secondaryLegendMetric: number;
    percentChange: number;
  };
}
